import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { YSButton } from "../../../uikit/YSButton";
import { YSSelectSearch } from "../../../uikit/YSSelectSearch";
import { useEffect, useState } from "react";
import { ErrorMessage, Form, Formik } from "formik";

import * as yup from "yup";
import {
  greyColor,
  warnColor,
  DatePickerField,
  BtnGroupStyle,
  DRxInputStyle,
  DRxSelectStyle,
  DRxTextareaStyle,
  InputSMBoxStyle,
} from "../../../Theme";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { loadingInitialTicket } from "../../../Redux/Slice/InitializeTicket";
import { NewTicketSubmit } from "../../../Apis/AuthApiServices";
import DRxInput from "../../../uikit/DRxInput";
import DRxSelect from "../../../uikit/DRxSelect";
import DRxTextarea from "../../../uikit/DRxTextarea";
import YSSnackBar from "../../../uikit/YSSnackBar";

const initialData = {
  dateOnIssueOccured: "",
  issueOccuredTo: "",
  mailId: "",
  prescribingAs: "",
  stateOfPratice: "",
  phoneNumber: "",
  issueSummery: "",
  issueRelatedTo: "",
  issueRelatedToSub: "",
  detailedDescription: "",
  prescribingAsLabel: "",
};
export default function NewTicket(props: any) {
  const { setMessage, setOpen, getTickets } = props;
  const { handleHideNewTicketPopupClick } = props;
  const dispatch = useDispatch();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const InitialTicketData = useSelector((state: any) => {
    return { ...state?.GetInitialTicketSlice };
  }); //To get data from redux store state
  const [stateData, setStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const InitialTicket = async () => {
    dispatch(loadingInitialTicket());
  };

  const createNewTicket = async (values: any) => {
    try {
      setLoading(true);
      let doctorId: any = localStorage.getItem("doctorId");
      let userData = {
        doctorId: doctorId,
        issueOccuredTo: values.issueOccuredTo,
        mailId: values.mailId,
        phoneNumber: values.phoneNumber,
        prescribingAs: values.prescribingAs,
        stateOfPratice: values.stateOfPratice,
        issueSummery: values.issueSummery,
        detailedDescription: values.detailedDescription,
        dateOnIssueOccured: values.dateOnIssueOccured,
        issueRelatedTo: values.issueRelatedTo,
        issueRelatedToSub: values.issueRelatedToSub,
      };

      const result: any = await NewTicketSubmit(userData);

      if (result?.data?.digitalRxStatusCode === 200) {
        handleHideNewTicketPopupClick();
        setMessage(result?.data?.response[0]?.message);
        setOpen(true);
        getTickets(0);
        setLoading(false);
      } else {
        setLoading(false);
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setLoading(false);
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  useEffect(() => {
    InitialTicket();
  }, []);

  return InitialTicketData.isLoading ? (
    <Grid
      container
      justifyContent={"center"}
      alignItems={"center"}
      height={"50vh"}
    >
      <CircularProgress />
    </Grid>
  ) : (
    <>
      <Formik
        initialValues={
          data
            ? data
            : {
                dateOnIssueOccured:
                  InitialTicketData.InitializeTicketData.dateOnIssueOccured ??
                  "",
                issueOccuredTo:
                  InitialTicketData.InitializeTicketData.issueOccuredTo ?? "",
                mailId: InitialTicketData.InitializeTicketData.mailId ?? "",
                prescribingAs:
                  InitialTicketData.InitializeTicketData.prescribingAs ?? "",
                stateOfPratice:
                  InitialTicketData.InitializeTicketData.stateOfPratice ?? "",
                phoneNumber:
                  InitialTicketData.InitializeTicketData.phoneNumber ?? "",
                issueSummery: "",
                issueRelatedTo: "",
                issueRelatedToSub: "",
                detailedDescription: "",
              }
        }
        enableReinitialize
        onSubmit={(values) => {
          createNewTicket(values);
        }}
        validationSchema={yup.object().shape({
          dateOnIssueOccured: yup
            .date()
            .required(
              "Invalid issue occurred date. Please select from Date Picker."
            ),
          issueOccuredTo: yup
            .string()
            .matches(/^[aA-zZ\s]+$/, "Name should be alphabetic characters.")
            .required("Invalid name. Please provide name")
            .max(50)
            .min(3),
          mailId: yup
            .string()
            .required("Invalid mail id. Please provide a valid mail id."),

          phoneNumber: yup
            .string()
            .matches(
              /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
              "Phone number is not valid"
            )
            .min(10, "too short")
            .max(10, "too long")
            .required("Required Phone Number"),
          prescribingAs: yup
            .string()
            .required("Please select prescriber profile from drop-down."),
          stateOfPratice: yup
            .string()
            .required("Please select state of practice"),
          issueSummery: yup
            .string()
            .required("issue summary required")
            .min(5)
            .max(500),
          detailedDescription: yup
            .string()
            .required("description required!")
            .min(5)
            .max(1000),
        })}
      >
        {(registerProps) => (
          <Form onSubmit={registerProps.handleSubmit}>
            <Grid
              container
              item
              xs={12}
              spacing={0}
              alignItems="top"
              justifyContent="space-between"
              columnSpacing={4}
              rowSpacing={1}
            >
              <Grid item xs={12} md={6}>
                <InputSMBoxStyle className="newticket">
                  <Typography
                    component="label"
                    color={greyColor}
                    variant="body2"
                    htmlFor="datewhenissueoccurred"
                    style={{ marginTop: "0 !important" }}
                  >
                    Date when issue occurred
                    <Typography
                      component="span"
                      color={warnColor}
                      variant="body1"
                    >
                      *
                    </Typography>
                  </Typography>{" "}
                  <DRxInputStyle className="date">
                    <DatePickerField>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="yyyy/MM/dd"
                          openTo="year"
                          value={
                            registerProps.values.dateOnIssueOccured === ""
                              ? null
                              : registerProps.values.dateOnIssueOccured
                          }
                          views={["year", "month", "day"]}
                          onChange={(e) => {
                            registerProps.setFieldValue(
                              "dateOnIssueOccured",
                              moment(e).format("YYYY-MM-DD")
                            );
                          }}
                          renderInput={(params) => (
                            <>
                              <TextField
                                {...params}
                                error={
                                  registerProps.touched.dateOnIssueOccured &&
                                  Boolean(
                                    registerProps.errors.dateOnIssueOccured
                                  )
                                }
                              />
                              <Typography
                                color="error"
                                className="error"
                                variant="body2"
                                component="div"
                              >
                                <ErrorMessage name="dateOnIssueOccured" />
                              </Typography>
                            </>
                          )}
                        />
                      </LocalizationProvider>
                    </DatePickerField>
                  </DRxInputStyle>
                </InputSMBoxStyle>
              </Grid>
              <Grid item xs={12} md={6}>
                <InputSMBoxStyle className="newticket">
                  <Typography
                    component="label"
                    color={greyColor}
                    variant="body2"
                    htmlFor="issueoccurredtoName"
                  >
                    Issue occurred to (Name){" "}
                    <Typography
                      component="span"
                      color={warnColor}
                      variant="body1"
                    >
                      *
                    </Typography>
                  </Typography>{" "}
                  <DRxInputStyle>
                    <DRxInput
                      id="issueoccurredtoName"
                      name="issueOccuredTo"
                      type="text"
                      className=""
                    />
                  </DRxInputStyle>
                </InputSMBoxStyle>
              </Grid>

              <Grid item xs={12} md={6}>
                <InputSMBoxStyle className="newticket">
                  <Typography
                    component="label"
                    color={greyColor}
                    variant="body2"
                    htmlFor="email"
                  >
                    Email
                    <Typography
                      component="span"
                      color={warnColor}
                      variant="body1"
                    >
                      *
                    </Typography>
                  </Typography>{" "}
                  <DRxInputStyle>
                    <DRxInput
                      id="email"
                      name="mailId"
                      type="email"
                      className="input"
                    />
                  </DRxInputStyle>
                </InputSMBoxStyle>{" "}
              </Grid>
              <Grid item xs={12} md={6}>
                <InputSMBoxStyle className="newticket">
                  <Typography
                    component="label"
                    color={greyColor}
                    variant="body2"
                    htmlFor="email"
                  >
                    Phone
                    <Typography
                      component="span"
                      color={warnColor}
                      variant="body1"
                    >
                      *
                    </Typography>
                  </Typography>{" "}
                  <DRxInputStyle>
                    <DRxInput
                      id="phone"
                      name="phoneNumber"
                      type="text"
                      className=""
                    />
                  </DRxInputStyle>
                </InputSMBoxStyle>{" "}
              </Grid>
              <Grid item xs={12} md={6}>
                <InputSMBoxStyle className="newticket">
                  <Typography
                    component="label"
                    color={greyColor}
                    variant="body2"
                    htmlFor="prescribing"
                  >
                    Prescribing as{" "}
                    <Typography
                      component="span"
                      color={warnColor}
                      variant="body1"
                    >
                      *
                    </Typography>
                  </Typography>
                  <DRxSelectStyle className="autosearch">
                    <DRxSelect
                      name="prescribingAs"
                      id="sub"
                      data={
                        InitialTicketData?.InitializeTicketData
                          ?.drxProfiles ?? [{ value: "", label: "" }]
                      }
                    />
                  </DRxSelectStyle>
                </InputSMBoxStyle>{" "}
              </Grid>
              <Grid item xs={12} md={6}>
                <InputSMBoxStyle className="newticket">
                  <Typography
                    component="label"
                    color={greyColor}
                    variant="body2"
                    htmlFor="stateofpractice"
                  >
                    State of practice{" "}
                    <Typography
                      component="span"
                      color={warnColor}
                      variant="body1"
                    >
                      *
                    </Typography>
                  </Typography>
                  <DRxSelectStyle className="autosearch">
                    <YSSelectSearch
                      id="stateofpractice"
                      options={
                        InitialTicketData?.InitializeTicketData?.statesMap ?? [
                          { value: "", label: "" },
                        ]
                      }
                      name="stateOfPratice"
                      value={registerProps.values.stateOfPratice}
                      onInputChange={(option: any, e: any) => {
                        registerProps.setFieldValue("stateOfPratice", e);
                      }}
                      onChange={(option: any, e: any) => {
                        registerProps.setFieldValue("stateOfPratice", e.label);
                      }}
                      error={
                        registerProps.touched.stateOfPratice &&
                        Boolean(registerProps.errors.stateOfPratice)
                      }
                    />
                  </DRxSelectStyle>
                </InputSMBoxStyle>{" "}
              </Grid>
              <Grid item xs={12} md={6}>
                <InputSMBoxStyle className="newticket">
                  <Typography
                    component="label"
                    color={greyColor}
                    variant="body2"
                    htmlFor="zip"
                  >
                    Issue summary
                    <Typography
                      component="span"
                      color={warnColor}
                      variant="body1"
                    >
                      *
                    </Typography>
                  </Typography>{" "}
                  <DRxTextareaStyle>
                    <DRxTextarea
                      className={""}
                      id={""}
                      placeholder={"Enter details"}
                      name="issueSummery"
                    />
                  </DRxTextareaStyle>
                </InputSMBoxStyle>{" "}
              </Grid>

              <Grid item xs={12} md={6}>
                <InputSMBoxStyle className="newticket">
                  <Typography
                    component="label"
                    color={greyColor}
                    variant="body2"
                    htmlFor="zip"
                  >
                    Detailed description of issue
                    <Typography
                      component="span"
                      color={warnColor}
                      variant="body1"
                    >
                      *
                    </Typography>
                  </Typography>{" "}
                  <DRxTextareaStyle>
                    <DRxTextarea
                      id={""}
                      className={""}
                      placeholder={"Enter details"}
                      name="detailedDescription"
                    />
                  </DRxTextareaStyle>
                </InputSMBoxStyle>{" "}
              </Grid>
              <Grid item xs={12} md={6}>
                <InputSMBoxStyle className="newticket">
                  {" "}
                  <Typography
                    component="label"
                    color={greyColor}
                    variant="body2"
                    htmlFor="main"
                  >
                    Issue related to{" "}
                  </Typography>
                  <DRxSelectStyle className="mr10">
                    <DRxSelect
                      name="issueRelatedTo"
                      id="main"
                      data={
                        InitialTicketData?.InitializeTicketData
                          ?.issueRelatedToMainDropdownOptions ?? [
                          { value: "", label: "" },
                        ]
                      }
                    />
                  </DRxSelectStyle>{" "}
                  <DRxSelectStyle>
                    {" "}
                    <DRxSelect
                      name="issueRelatedToSub"
                      id="sub"
                      data={
                        InitialTicketData?.InitializeTicketData
                          ?.issueRelatedToSubDropdownOptions ?? [
                          { value: "", label: "" },
                        ]
                      }
                    />
                  </DRxSelectStyle>
                </InputSMBoxStyle>
              </Grid>
              <Grid item xs={12} md={6}></Grid>

              <Grid item xs={12}>
                <BtnGroupStyle className="right">
                  <YSButton
                    size="large"
                    className=""
                    color="secondary"
                    dataTestId="submitBtn"
                    variant="outlined"
                    disabled={false}
                    type="button"
                    children={"Cancel"}
                    onClick={handleHideNewTicketPopupClick}
                  />
                  <YSButton
                    size="large"
                    className=""
                    color="secondary"
                    dataTestId="submitBtn"
                    variant="outlined"
                    disabled={false}
                    type="button"
                    children={"Reset"}
                    onClick={() => setData(initialData)}
                  />
                  <YSButton
                    size="large"
                    className=""
                    color="primary"
                    dataTestId="submitBtn"
                    variant="contained"
                    disabled={false}
                    type="submit"
                    children={
                      loading ? (
                        <CircularProgress size={28} color={"inherit"} />
                      ) : (
                        "Create"
                      )
                    }
                  />{" "}
                </BtnGroupStyle>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
      <YSSnackBar
        message={stateData.message}
        variant={stateData.variant}
        open={stateData.open}
        handleClose={() => {
          setStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
